var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-config-provider", { attrs: { locale: _vm.locale } }, [
    _c(
      "div",
      { staticClass: "ch2-hidden-overflow", attrs: { id: "app" } },
      [
        _c("router-view"),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showBackTop,
                expression: "showBackTop"
              }
            ],
            staticClass: "back-to-top",
            on: { click: _vm.backToTop }
          },
          [_vm._v(" ↑ 返回顶部 ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }